var o = (e => (e.OPEN = "open", e.EDITING = "editing", e.CLOSED = "closed", e))(o || {});
export { o as DropdownStates };